import { FC, useMemo, useState } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { Button } from '@corratech/pylot-ui'
import cn from 'classnames'
import type { Maybe, Wishlist } from '@pylot-data/pylotschema'
import { CreateWishlist } from '../CreateWishlist'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import s from '@pagestyles/Wishlist.module.scss'

export type Props = {
    wishlists: Maybe<Wishlist>[]
}

export const WishlistNav: FC<Props> = ({ wishlists }) => {
    const { t } = useTranslation(['wishlist'])
    const { query } = useRouter()
    const [show, setShow] = useState(false)
    const config = useStoreConfig()

    const getIsActiveLink = (id: string) => {
        if (!query?.id) {
            return id === wishlists[0]?.id
        }
        return id === query?.id
    }

    const navigation = useMemo(() => {
        if (wishlists?.length === 0) return null //by default a user will have at least one wishlist

        return wishlists?.map((wishlist, key) => (
            <li
                key={key}
                className={cn(s['nav-list-item'], {
                    [s.active]: getIsActiveLink(wishlist?.id!)
                })}
            >
                <Link href={`/account/wishlist/${wishlist?.id}`}>
                    {wishlist?.name}
                </Link>
            </li>
        ))
    }, [wishlists, query])

    if (!config.base.wishlist.multiple_wishlists) return null

    return (
        <nav className={s['wishlist-nav']}>
            <div className={s['wishlist-head']}>{t('wishlist|Wish List:')}</div>
            <ul className={s['wishlist-nav-list']}>{navigation}</ul>
            <div className={s['wishlist-create-btn-container']}>
                <Button
                    onClick={() => setShow(true)}
                    onKeyUp={() => setShow(true)}
                    variant="link"
                >
                    {t('wishlist|Create New Wish List')}
                </Button>
                <CreateWishlist show={show} setShow={setShow} />
            </div>
        </nav>
    )
}
